import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/utils";

const scrollStripClass =
  "-mx-1 flex gap-2 overflow-x-auto px-1 pb-1 scroll-smooth snap-x snap-mandatory touch-pan-x [scrollbar-width:none] [&::-webkit-scrollbar]:hidden [mask-image:linear-gradient(to_right,transparent,black_14px,black_calc(100%-14px),transparent)] [-webkit-mask-image:linear-gradient(to_right,transparent,black_14px,black_calc(100%-14px),transparent)]";

interface HorizontalScrollStripProps extends HTMLAttributes<HTMLDivElement> {
  hint?: ReactNode;
  scrollClassName?: string;
  children: ReactNode;
}

/** Horizontal scroll row with edge fade and snap — hours, days, poll tabs. */
export function HorizontalScrollStrip({
  hint,
  className,
  scrollClassName,
  children,
  ...props
}: HorizontalScrollStripProps) {
  return (
    <div className={cn("space-y-1.5", className)}>
      {hint}
      <div className={cn(scrollStripClass, scrollClassName)} {...props}>
        {children}
      </div>
    </div>
  );
}
